import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { AssignedSkillsComponent } from '@app/onboarding/components/assigned-skills/assigned-skills.component';
import { OnboardingViewComponent } from '@app/onboarding/components/onboarding-view/onboarding-view.component';
import { ResumeParsingComponent } from '@app/onboarding/components/resume-parsing/resume-parsing.component';
import { RoleSelectComponent } from '@app/onboarding/components/role-select/role-select.component';
import { SkillsComponent } from '@app/onboarding/components/skills/skills.component';
import { StartLearningComponent } from '@app/onboarding/components/startlearning/startlearning.component';
import { WelcomeComponent } from '@app/onboarding/components/welcome/welcome.component';
import { ReviewSkillsComponent } from './components/review-skills/review-skills.component';

// Guards
import { ResumeParsingBaseGuard } from '@app/onboarding/guards/resume-parsing.guard';

const onboardingRoutes: Routes = [
  {
    path: '',
    component: OnboardingViewComponent,
    children: [
      {
        path: 'welcome',
        component: WelcomeComponent,
      },
      {
        path: 'startlearning',
        component: StartLearningComponent,
      },
      {
        path: 'skills',
        component: SkillsComponent,
      },
      {
        path: 'roleselect',
        component: RoleSelectComponent,
      },
      {
        path: 'assigned',
        component: AssignedSkillsComponent,
      },
      {
        path: 'resume',
        canActivate: [ResumeParsingBaseGuard],
        component: ResumeParsingComponent,
      },
      {
        path: 'review',
        component: ReviewSkillsComponent,
      },
      {
        path: '',
        redirectTo: '/getstarted/welcome',
        pathMatch: 'full',
      }, // redirect to welcome if no other route specified
    ],
  },
];
@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(onboardingRoutes)],
  exports: [RouterModule],
})
export class OnboardingRoutingModule {}
